import { warn } from '../../../logger';
import { InternalElementFactoryOptions, SdkElement } from '../../../model';
import { recordEvent } from '../../../telemetry';
import { SDKError } from '../../error';
import {
  DocumentCollectorElement,
  DocumentCollectorElementOptions
} from './DocumentCollectorElement';
import { parseDocumentCollectorOptions } from './documentCollectorOptionsSchema';

export const createDocumentCollectorElement = async (
  elementOptions: DocumentCollectorElementOptions,
  commonOptions: InternalElementFactoryOptions
): Promise<SdkElement> => {
  await recordEvent('sdk_document_collector_element_init_options', {
    document_collector_element_options: { ...elementOptions },
    elements_options: commonOptions
  });

  const {
    errors,
    warnings,
    options: validatedOptions,
    initialOptions
  } = parseDocumentCollectorOptions(elementOptions);

  if (errors) {
    throw new SDKError(
      'invalidDocumentCollectorElementOptions',
      'Invalid Document Collector Element options provided.',
      errors
    );
  }

  if (warnings) {
    warn('invalidDocumentCollectorElementOptions', warnings);
  }

  await recordEvent('sdk_document_collector_element_options_validated', {
    document_collector_element_warnings: warnings,
    document_collector_element_options: initialOptions,
    elements_options: commonOptions
  });

  return DocumentCollectorElement({ ...validatedOptions, ...commonOptions });
};
